const HourTime = (props) => {
	const { operational } = props;

	return (
		<div className='h-full flex flex-col my-2'>
			{operational?.map((op, index) => {
				return (
					<div key={index} className={`grid grid-cols-[110px_1fr] py-1 font-normal text-xs ${op?.isActive ? 'text-[var(--rose-violet)]' : 'text-gray-500'}`}>
						<div>{op?.hari}</div>
						<div>{op?.jam}</div>
					</div>
				);
			})}
		</div>
	);
};

export default HourTime;
